// extracted by mini-css-extract-plugin
export default {"fill":"mediaFrame_fill__WNAo1","inline":"mediaFrame_inline__d3xl7","playButton":"mediaFrame_playButton__9+VLu"};